const API_BASE = '/api'

export class ApiRequestError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.status = status
    this.name = 'ApiRequestError'
  }
}

let onUnauthorized: (() => void) | null = null

export function registerUnauthorizedHandler(handler: () => void) {
  onUnauthorized = handler
}

function authHeaders(): Record<string, string> {
  const raw = localStorage.getItem('nexo_session')
  if (!raw) return {}
  try {
    const session = JSON.parse(raw)
    return session?.token ? { 'X-Nexo-Token': session.token } : {}
  } catch {
    return {}
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(API_BASE + path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
      ...init?.headers,
    },
  })

  if (res.status === 401) {
    onUnauthorized?.()
    throw new ApiRequestError(401, 'sesion_expirada')
  }

  if (!res.ok) {
    let message = String(res.status)
    try {
      const body = await res.json()
      if (body?.error) message = body.error
    } catch {
      // body no era JSON, se deja el status como mensaje
    }
    throw new ApiRequestError(res.status, message)
  }

  if (res.status === 204) return undefined as T
  return (await res.json()) as T
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
  patch: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'PATCH', body: body ? JSON.stringify(body) : undefined }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
}

export async function loginRequest(email: string, password: string) {
  const res = await fetch(API_BASE + '/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  })
  if (res.status === 401) throw new ApiRequestError(401, 'credenciales_invalidas')
  if (!res.ok) throw new ApiRequestError(res.status, String(res.status))
  return res.json()
}
